import { render, staticRenderFns } from "./StoryTextBox.vue?vue&type=template&id=353eb7b6&scoped=true&"
import script from "./StoryTextBox.vue?vue&type=script&lang=js&"
export * from "./StoryTextBox.vue?vue&type=script&lang=js&"
import style0 from "./StoryTextBox.vue?vue&type=style&index=0&id=353eb7b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353eb7b6",
  null
  
)

export default component.exports